<template>
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <g opacity="0.5">
            <path d="M21 3H9C8.20435 3 7.44129 3.31607 6.87868 3.87868C6.31607 4.44129 6 5.20435 6 6V30C6 30.7956 6.31607 31.5587 6.87868 32.1213C7.44129 32.6839 8.20435 33 9 33H27C27.7956 33 28.5587 32.6839 29.1213 32.1213C29.6839 31.5587 30 30.7956 30 30V12L21 3Z" stroke="#858E97" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M21 3V12H30" stroke="#858E97" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M18 27V18" stroke="#858E97" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.5 22.5H22.5" stroke="#858E97" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'IconUpload',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
